import { render, staticRenderFns } from "./candidate-select.vue?vue&type=template&id=8905ead0&scoped=true"
import script from "./candidate-select.vue?vue&type=script&lang=ts"
export * from "./candidate-select.vue?vue&type=script&lang=ts"
import style0 from "./candidate-select.vue?vue&type=style&index=0&id=8905ead0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8905ead0",
  null
  
)

export default component.exports